import { Link } from "react-router-dom";

function LoginSection() {
    return (
        <>
            <div className="my-account-area pt-100 pb-70">
                <div className="container">
                    <div className="login-form">
                        <form className="my-account-content" onSubmit={(e)=>e.preventDefault()}>
                            <div className="section-title">
                                <h2>LogIn as Service Provider</h2>
                                <span className="top-title">Keep Connected With Us</span>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="email" className="form-control" placeholder="Email Address" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required minLength={8} type="password" className="form-control" placeholder="Password" />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="form-group">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                            <label className="form-check-label" for="flexCheckDefault">
                                                Remember Me
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="text-account">
                                        <p><Link to={'/forgot'}>Forgot Password?</Link> </p>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit" className="default-btn btn-style-fore">Login as Servive provider</button>
                                </div>
                            </div>
                            <p>Don’t Have an Account? <Link to={'/provider-register'}>Register</Link></p>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginSection